import React from "react";
import clsx from "clsx";
import PaymentGatewayTester from "../../PaymentGatewayTester/PaymentGatewayTester";

export default class PropertyDetailsBuilderGeneral extends React.Component {
    constructor(props) {
      super(props)
    }

    render() {
      var tabClasses = clsx({
          'active': this.props.active_tab == 'payment_gateway',
          'tab-pane': true,
      })

      return (
        <div className={tabClasses} id="payment_gateway">
          <PaymentGatewayTester {...this.props} gateways={this.props.payment_gateway ? [this.props.payment_gateway] : []} property_id={this.props.property.id} />
        </div>
      )
    }
}
